import styled from 'styled-components';

import { mobile } from './utils/breakpoints';

export const ShowOnDesktop = styled.div`
  @media only screen and (max-width: ${mobile}) {
    display: none;
  }
`;
